import { useMemo, useState } from 'react';

import { useCart } from '../../../../hooks/useCart';

import { ReactComponent as PlusIcon } from '../../../../icons/plus-circular.svg';

import './menu-list-item.scss';

import { Currency } from '../../../../utils/currency/Currency';
import { MenuItemOptionsModal } from '../../../modal/menu-item-options/MenuItemOptionsModal';
import { QuantitySelector } from '../../../quantity-selector/QuantitySelector';
import { ExpandableText } from '../../../see-more/ExpandableText';

export const MenuListItem = ({ item }) => {
  const { addToCart, cart, isItemInCart, incrementItem, decrementItem } = useCart();
  const [showOptionsModal, setShowOptionsModal] = useState(false);

  const hasOptions = item.optionGroups?.length > 0;

  const isInCart = useMemo(() => {
    return isItemInCart(item);
    //eslint-disable-next-line
  }, [cart]);

  const cartItem = useMemo(() => {
    return cart.items.find((cartItem) => cartItem.id === item.id);
  }, [cart, item]);

  return (
    <div className="menu-list-item">
      <img src={item.imageUrl} alt={`Menu List Item ${item.id}`} />
      <div>
        <div>
          <span className="menu-list-item__name">{item.name}</span>
          <Currency className="menu-list-item__price" value={item.price} />
        </div>
        <div>
          <span className="menu-list-item__description">
            <ExpandableText text={item.description} maxChars={150} />
          </span>
          {(!isInCart || hasOptions) && (
            <PlusIcon
              className="menu-list-item__add"
              width={24}
              height={24}
              onClick={() => (hasOptions ? setShowOptionsModal(true) : addToCart(item))}
            />
          )}
        </div>
        {isInCart && !hasOptions && (
          <div className="menu-list-item__quantity">
            <QuantitySelector
              quantity={cartItem.quantity}
              onIncrement={() => incrementItem(item)}
              onDecrement={() => decrementItem(item)}
            />
          </div>
        )}
      </div>
      {hasOptions && (
        <MenuItemOptionsModal
          open={showOptionsModal}
          onOpen={setShowOptionsModal}
          item={item}
          onConfirm={({ selectedOptionIds, selectedOptions, priceDelta }) => {
            addToCart({
              ...item,
              basePrice: item.price,
              price: item.price + priceDelta,
              selectedOptionIds,
              selectedOptions
            });
          }}
        />
      )}
    </div>
  );
};
